import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { HoldsKillsChartView } from './HoldsKillsChartView';
import * as actions from '../actions/confirmTicketingActionCreators';

export { HoldsKillsChartView };

const HoldsKillsChart = ({
  csrfToken,
  selectedEvent,
  holds,
  kills,
  seatsIOPublicKey,
  fetchHolds,
  fetchKills,
}) => {
  const eventId = selectedEvent?.id;

  useEffect(() => {
    if (!eventId) return undefined;
    const controller = new AbortController();
    fetchHolds(csrfToken, selectedEvent, controller.signal);
    fetchKills(csrfToken, selectedEvent, controller.signal);
    return () => controller.abort();
  }, [eventId]);

  return (
    <HoldsKillsChartView
      selectedEvent={selectedEvent}
      holds={holds}
      kills={kills}
      seatsIOPublicKey={seatsIOPublicKey}
    />
  );
};

HoldsKillsChart.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  selectedEvent: PropTypes.object,
  holds: PropTypes.array,
  kills: PropTypes.array,
  seatsIOPublicKey: PropTypes.string,
  fetchHolds: PropTypes.func.isRequired,
  fetchKills: PropTypes.func.isRequired,
};

HoldsKillsChart.defaultProps = {
  selectedEvent: null,
  holds: [],
  kills: [],
  seatsIOPublicKey: '',
};

const mapStateToProps = (state) => ({
  csrfToken: state.csrfToken,
  holds: state.holds,
  kills: state.kills,
  seatsIOPublicKey: state.seatsIOPublicKey,
});

const mapDispatchToProps = (dispatch) => ({
  fetchHolds: (csrfToken, seatingChartEvent, signal) => dispatch(actions.fetchHolds(dispatch, csrfToken, seatingChartEvent, signal)),
  fetchKills: (csrfToken, seatingChartEvent, signal) => dispatch(actions.fetchKills(dispatch, csrfToken, seatingChartEvent, signal)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HoldsKillsChart);
